// @flow
import NewsletterSignupContainer from './NewsletterSignupContainer';

export default NewsletterSignupContainer;
